module.exports = __webpack_public_path__ + "static/img/30.791716a.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/ITO/30.png
// module id = GfvE
// module chunks = 1